import React, { useEffect } from "react";
import { Helmet } from "react-helmet";

import AllProjects from "../components/projects/allProjects";

import INFO from "../data/user";
import SEO from "../data/seo";
import usePageReveal from "../hooks/usePageReveal";

import "./styles/projects.css";

const Projects = () => {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);
	usePageReveal([]);

	const currentSEO = SEO.find((item) => item.page === "projects");

	return (
		<React.Fragment>
			<Helmet>
				<title>{`Projects | ${INFO.main.title}`}</title>
				<meta name="description" content={currentSEO.description} />
				<meta
					name="keywords"
					content={currentSEO.keywords.join(", ")}
				/>
			</Helmet>

			<div className="page-content">
				<div className="content-wrapper">
					<div className="projects-container">
						<div className="projects-eyebrow" data-reveal>
							● PROJECTS · THINGS I'VE MADE
						</div>
						<div className="title projects-title" data-reveal>
							Completed
						</div>
						<div className="subtitle projects-subtitle" data-reveal>
							I’ve worked on a variety of projects over the years
							and I’m proud of the progress I’ve made. A lot of
							these projects were for fun, useful to me, or were
							an opportunity to learn. Go ahead and check the ones
							with links out.
						</div>

						<div className="projects-list" data-reveal>
							<AllProjects projects={INFO.projects} />
						</div>

						<hr className="projects-divider" data-reveal />

						<div className="title projects-wip-title" data-reveal>
							Currently Building
						</div>
						<div className="subtitle projects-subtitle" data-reveal>
							Projects I’m actively working on — not ready to
							share yet.
						</div>

						<div className="projects-list" data-reveal>
							<AllProjects projects={INFO.projectsInProgress} />
						</div>
					</div>
				</div>
			</div>
		</React.Fragment>
	);
};

export default Projects;
